import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-followers';

export default function Example() {
  return (
    <>
      <Head>
        <title>How to Increase Your Depop Followers Like a Pro</title>
        <meta
          name='description'
          content='Whether you’re a new or a pro seller, these tips and tricks will still significantly contribute to the growth of your Depop follower count'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-followers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-followers' />
        <meta property='og:title' content='How to Increase Your Depop Followers Like a Pro' />
        <meta
          property='og:description'
          content='Whether you’re a new or a pro seller, these tips and tricks will still significantly contribute to the growth of your Depop follower count'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
